import type { FaireProductEntity } from "../../entity_types/product";

export const p_2g45nrqc7k: FaireProductEntity = {
  token: "p_2g45nrqc7k",
  type: "product",
  name: "Goat Milk Lotion Hand Cream Body Lotion Travel Size Lotion",
  brandName: "One Blessed Acre Farm",
  imageUrl:
    "https://cdn.faire.com/fastly/675541081b3aec6e242142e4585c8c4ea62070fa46865df8028cb7c2810829c9.jpeg",
  priceDollars: 2.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/27b25d4ab8560884613a482a9287030392c4d296be3a55147875ed7fa0e2f7e3.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
